import { Carousel, CarouselItem } from 'react-bootstrap';
import { useState } from 'react';
import {
    ApproveDeclineProjectSlideContent,
    ApproveDeclineProjectSlideImage,
    ApproveDeclineProjectSlideImageSrc,
} from './slides/ApproveDeclineProjectSlide';
import { Slide } from '../slider/Slide';
import './SupervisorTutorial.css';
import {
    HelloSupervisorSlideContent,
    HelloSupervisorSlideImage,
    HelloSupervisorSlideImageSrc,
} from './slides/HelloSupervisorSlide';
import {
    StraightForwardProjectHandlingSlideContent,
    StraightForwardProjectHandlingSlideImage,
    StraightForwardProjectHandlingSlideImageSrc,
} from './slides/StraightForwardProjectHandlingSlide';
import {
    MentorAndGradeSlideContent,
    MentorAndGradeSlideImage,
    MentorAndGradeSlideImageSrc,
} from './slides/MentorAndGradeSlide';
import {
    StudentMoreTimeSlideContent,
    StudentMoreTimeSlideImage,
    StudentMoreTimeSlideImageSrc,
} from './slides/StudentMoreTimeSlide';
import {
    ManageResearchAreaSlideContent,
    ManageResearchAreaSlideImage,
    ManageResearchAreaSlideImageSrc,
} from './slides/ManageResearchAreaSlide';
import {
    ThingsToKeepInMindSlideContent,
    ThingsToKeepInMindSlideImage,
    ThingsToKeepInMindSlideImageSrc,
} from './slides/ThingsToKeepInMindSlide';
import { ILocalization } from '../../../../localization/definitions/types';
import { RootState } from '../../../../store';
import { connect } from 'react-redux';

interface Props {
    closeModal: () => void;
    localization: ILocalization;
}
const SupervisorTutorial = ({ closeModal, localization }: Props) => {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex: number) => {
        setIndex(selectedIndex);
    };

    const onNextBtnClick = () => {
        handleSelect(index + 1);
    };

    const onBackBtnClick = () => {
        handleSelect(index - 1);
    };

    const onFinishBtnClick = () => {
        closeModal();
    };

    const supervisorSlides = [
        {
            content: (
                <HelloSupervisorSlideContent localization={localization} />
            ),
            image: <HelloSupervisorSlideImage />,
            imgSource: HelloSupervisorSlideImageSrc,
        },
        {
            content: (
                <StraightForwardProjectHandlingSlideContent
                    localization={localization}
                />
            ),
            image: <StraightForwardProjectHandlingSlideImage />,
            imgSource: StraightForwardProjectHandlingSlideImageSrc,
        },
        {
            content: (
                <ApproveDeclineProjectSlideContent
                    localization={localization}
                />
            ),
            image: <ApproveDeclineProjectSlideImage />,
            imgSource: ApproveDeclineProjectSlideImageSrc,
        },
        {
            content: <MentorAndGradeSlideContent localization={localization} />,
            image: <MentorAndGradeSlideImage />,
            imgSource: MentorAndGradeSlideImageSrc,
        },
        {
            content: (
                <StudentMoreTimeSlideContent localization={localization} />
            ),
            image: <StudentMoreTimeSlideImage />,
            imgSource: StudentMoreTimeSlideImageSrc,
        },
        {
            content: (
                <ManageResearchAreaSlideContent localization={localization} />
            ),
            image: <ManageResearchAreaSlideImage />,
            imgSource: ManageResearchAreaSlideImageSrc,
        },
        {
            content: (
                <ThingsToKeepInMindSlideContent localization={localization} />
            ),
            image: <ThingsToKeepInMindSlideImage />,
            imgSource: ThingsToKeepInMindSlideImageSrc,
        },
    ];

    const isLastSlide = () => {
        return index === supervisorSlides.length - 1;
    };

    return (
        <div
            className={`${isLastSlide() ? 'hide-dots' : ''} tutorial-carousel`}
            data-testid={'tutorial-slider'}
        >
            <Carousel
                interval={null}
                activeIndex={index}
                onSelect={handleSelect}
            >
                {supervisorSlides.map((slide, i) => (
                    <CarouselItem key={i}>
                        <Slide
                            localization={localization}
                            slide={{ ...slide, index: i }}
                            numberOfSlides={supervisorSlides.length}
                            onBackBtnClick={onBackBtnClick}
                            onFinishBtnClick={onFinishBtnClick}
                            onNextBtnClick={onNextBtnClick}
                        />
                    </CarouselItem>
                ))}
            </Carousel>
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        localization: state.localization,
    };
};

export default connect(mapStateToProps)(SupervisorTutorial);
